import React from 'react';
import { Button } from './ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
export function CookiePolicy() {
  return <section className="py-16 bg-white" data-id="element-112">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <div className="max-w-4xl mx-auto" data-id="element-114">
          <div className="mb-10 flex items-center" data-id="element-115">
            <Button variant="ghost" className="mr-4" href="/" data-id="element-116">
              <ArrowLeftIcon className="mr-2" size={16} data-id="element-117" />
              Back to home
            </Button>
          </div>
          <div className="border-2 border-[#00A862] rounded-xl p-8 shadow-md bg-white" data-id="element-118">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-119">
              Nexio App Cookie Policy
            </h1>
            <div className="bg-gray-50 px-4 py-2 rounded-lg inline-block mb-6" data-id="element-120">
              <p className="text-gray-600" data-id="element-121">Effective Date: 01-10-2025</p>
            </div>
            <div className="prose max-w-none text-gray-700" data-id="element-122">
              <p className="mb-6" data-id="element-123">
                This Cookie Policy explains how Nexio App uses cookies and
                similar technologies to recognize you when you visit our website
                or use our application. It explains what these technologies are,
                why we use them, and your choices regarding their use.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-124">
                1. What Are Cookies?
              </h2>
              <p className="mb-6" data-id="element-125">
                Cookies are small text files stored on your device when you
                visit a website. They are widely used to make websites work
                efficiently, improve user experience, and provide information to
                site owners.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-126">
                2. Types of Cookies We Use
              </h2>
              <ul className="space-y-2 mb-6" data-id="element-127">
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-128">
                  <span className="font-medium" data-id="element-129">Essential Cookies</span> - These
                  are necessary for the website and app to function. They enable
                  core features like logging in, managing your account, and
                  processing payments.
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-130">
                  <span className="font-medium" data-id="element-131">
                    Performance & Analytics Cookies
                  </span>{' '}
                  - These help us understand how users interact with Nexio App
                  (e.g., pages visited, time spent, errors). This data helps us
                  improve functionality and performance.
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-132">
                  <span className="font-medium" data-id="element-133">Functional Cookies</span> -
                  These remember your preferences (e.g., language, region) and
                  personalize your experience.
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-134">
                  <span className="font-medium" data-id="element-135">
                    Advertising & Marketing Cookies
                  </span>{' '}
                  - These may be used to deliver relevant ads or measure the
                  effectiveness of campaigns. We only use these with your
                  consent.
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-136">
                3. Third-Party Cookies
              </h2>
              <p className="mb-6" data-id="element-137">
                Some cookies are placed by trusted third-party services, such as
                analytics providers (e.g., Google Analytics) or payment
                processors. These third parties may collect information about
                your online activities across websites and services.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-138">
                4. How We Use Cookies
              </h2>
              <p className="mb-4" data-id="element-139">We use cookies to:</p>
              <ul className="space-y-2 mb-6" data-id="element-140">
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-141">
                  Keep you signed in and secure
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-142">
                  Remember your preferences
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-143">
                  Analyze usage to improve our app
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-144">
                  Provide relevant content and marketing
                </li>
              </ul>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-145">
                5. Your Choices
              </h2>
              <p className="mb-4" data-id="element-146">You have control over cookies:</p>
              <ul className="space-y-2 mb-6" data-id="element-147">
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-148">
                  <span className="font-medium" data-id="element-149">Browser Settings:</span> Most
                  browsers allow you to block or delete cookies.
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-150">
                  <span className="font-medium" data-id="element-151">Consent Banner:</span> On your
                  first visit, you can accept or decline non-essential cookies
                  via our cookie banner.
                </li>
                <li className="pl-4 border-l-2 border-[#9FD8B8]" data-id="element-152">
                  <span className="font-medium" data-id="element-153">Opt-Out:</span> You can update
                  cookie preferences at any time in your account settings or
                  browser.
                </li>
              </ul>
              <p className="mb-6" data-id="element-154">
                Please note that disabling essential cookies may affect the
                functionality of Nexio App.
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-155">
                6. Updates to this Policy
              </h2>
              <p className="mb-6" data-id="element-156">
                We may update this Cookie Policy from time to time. Changes will
                be posted with a new "Effective Date."
              </p>
              <h2 className="text-xl font-bold text-[#00A862] mt-8 mb-4 border-b border-gray-200 pb-2" data-id="element-157">
                7. Contact Us
              </h2>
              <p className="mb-6" data-id="element-158">
                For any questions about our use of cookies, please contact:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-100 shadow-sm" data-id="element-159">
                <p className="flex items-center justify-center space-x-4" data-id="element-160">
                  <span data-id="element-161">
                    📧{' '}
                    <a href="mailto:info@nexioapp.cloud" className="text-[#00A862] hover:underline" data-id="element-162">
                      info@nexioapp.cloud
                    </a>
                  </span>
                  <span data-id="element-163">
                    🌐{' '}
                    <a href="https://nexioapp.cloud" className="text-[#00A862] hover:underline" data-id="element-164">
                      nexioapp.cloud
                    </a>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}